import React from 'react';
import { Overview } from 'src/features/DA/components/templates/Overview';
import { Page } from '../../components/molecules/Page';
import { DAKeyMetrics } from '../../features/DA/components/organisms/DAKeyMetrics';
import { FilterBar } from '../../components/organisms/FilterBar';
import { GenAIActionButtons } from 'src/components/molecules/GenAIActionButtons';

export const OverviewPage: React.FC = () => {
  return (
    <Page
      filterBar={<FilterBar includeBenchmark />}
      pageTitle="Overview"
      pageSubtitle="Track your project and goal with full information"
      keyMetrics={<DAKeyMetrics />}
      extraButtons={<GenAIActionButtons />}
      // genAiInsights={IS_DEV ? <GenAIInsights /> : null}
    >
      <Overview />
    </Page>
  );
};
